import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import documentoService from '../../../service/administracion/documentoService';
import planCuentaService from '../../../service/administracion/planCuentaService';
import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            filter: {
                nombre: '',
                estado: -1,
                ...FILTER
            },
            pagination: PAGINATION,
            planesCuentaPENVenta: [],
            planesCuentaUSDVenta: [],
            planesCuentaPENCompra: [],
            planesCuentaUSDCompra: [],
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            compraPEN: 0,
            compraUSD: 0,
            ventaPEN: 0,
            ventaUSD: 0,
            listaDocumento: []
        };
    };

    handleClearFilters = () => {
        var filter = {
            nombre: '',
            estado: -1,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (value, row) => {
        var listaDocumento = this.state.formValues.listaDocumento.filter((m) => {
            return m.id == value;
        });

    };

    handleChangeForm = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };


    handleCambio = (property, value) => {
        const formValues = { ...this.state.formValues, [property]: value };
        this.setState({ formValues });
    };

    /******************** FORM MODAL *****************/

    handleEdit = async (values) => {
        // const response = await marcaService.obtenerPorId(values.id);
        // if (response !== undefined) {
        //     this.setState({
        //         visible: true,
        //         formValues: {
        //             id: response.id,
        //             nombre: response.nombre
        //         }
        //     });
        // }

        const response = await documentoService.listarPorIdTipoComprobante(values.id);
        this.setState({
            visible: true,
            formValues: {
                nombre: values.nombre,
                codigoSunat: values.codigoSunat,
                data: response
            }
        });
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            response = await documentoService.registrar(values);

            // if (values.id === 0)
            //     response = await documentoService.registrar(values);
            // else
            //     response = await documentoService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, documentoService.paginacion);
        const planesCuenta = await planCuentaService.listarPorMayorGrado({ idGrado: 0 });

        const planesCuentaPENVenta = planesCuenta.filter(m => m.idTipoCambio == 2 && m.idMoneda == 1);
        const planesCuentaUSDVenta = planesCuenta.filter(m => m.idTipoCambio == 2 && m.idMoneda == 2);
        const planesCuentaPENCompra = planesCuenta.filter(m => m.idTipoCambio == 1 && m.idMoneda == 1);
        const planesCuentaUSDCompra = planesCuenta.filter(m => m.idTipoCambio == 1 && m.idMoneda == 2);
        this.setState({
            planesCuentaPENVenta: planesCuentaPENVenta ? planesCuentaPENVenta : [],
            planesCuentaUSDVenta: planesCuentaUSDVenta ? planesCuentaUSDVenta : [],
            planesCuentaPENCompra: planesCuentaPENCompra ? planesCuentaPENCompra : [],
            planesCuentaUSDCompra: planesCuentaUSDCompra ? planesCuentaUSDCompra : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Documento"
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />

                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />

                <ResultList
                    pagination={this.state.pagination}
                    onEdit={this.handleEdit}
                    onChange={this._handleChangePagination}
                />

                <FormModal
                    planesCuentaPENVenta={this.state.planesCuentaPENVenta}
                    planesCuentaUSDVenta={this.state.planesCuentaUSDVenta}
                    planesCuentaPENCompra={this.state.planesCuentaPENCompra}
                    planesCuentaUSDCompra={this.state.planesCuentaUSDCompra}
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChange={this.handleChangeForm}
                    onCambio={this.handleCambio}
                />
            </div>
        );
    };
}